import { RechnungStatus } from '../types';

// Anzeige-Labels und Badge-Farben für Rechnungs-Status (Single Source – Liste, Detailseite,
// Kunde-Detailseite). "Überfällig" wird separat rot markiert (siehe UEBERFAELLIG_COLOR).
export const RECHNUNG_STATUS_LABEL: Record<RechnungStatus, string> = {
  ENTWURF: 'Entwurf',
  GESTELLT: 'Gestellt',
  BEZAHLT: 'Bezahlt',
  STORNIERT: 'Storniert',
};

export const RECHNUNG_STATUS_COLOR: Record<RechnungStatus, string> = {
  ENTWURF: 'bg-amber-100 text-amber-800',
  GESTELLT: 'bg-blue-100 text-blue-800',
  BEZAHLT: 'bg-green-100 text-green-800',
  STORNIERT: 'bg-gray-200 text-gray-600',
};

export const UEBERFAELLIG_COLOR = 'bg-red-100 text-red-800';

/** Noch abzuarbeiten – fürs Dashboard und Zähler. */
export const OFFENE_RECHNUNG_STATUS: RechnungStatus[] = ['ENTWURF', 'GESTELLT'];

// ISO-Datum (yyyy-mm-dd) -> dd.mm.yyyy, ohne Zeitzonen-Verschiebung.
export const fmtDatum = (iso?: string | null): string => {
  if (!iso) return '–';
  const [y, m, d] = iso.split('T')[0].split('-');
  if (!y || !m || !d) return iso;
  return `${d}.${m}.${y}`;
};
